import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncAdditionalAmount = loadable(
  () => import('./AdditionalAmount'),
  {
    fallback: <Loader />,
  },
);
